import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { mapMutations } from "vuex";
import * as types from "@board/store/types";
import * as dateutil from "@/util/date-helper";
@Component({
    components: {},
    methods: {
        ...mapMutations({
            setCurrentArticle: types.BOARD_ARTICLE_CURRENT,
        }),
    },
})
export default class BoardListItem extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //
    @Prop({ type: Object }) item!: article.Article;

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    setCurrentArticle!: (item: article.Article) => void;

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    showNewIcon(article: article.Article) {
        var oneDay = 1000 * 60 * 60 * 24;
        var createdDate = new Date(article.createdDate.toString());
        var today = new Date();

        var timeSpan = today.getTime() - createdDate.getTime();

        //임시저장 문서는 표시되지 않음
        if (timeSpan <= oneDay && article.isDraft == false) {
            return true;
        } else {
            return false;
        }
    }

    showUpdateIcon(article: article.Article) {
        var oneDay = 1000 * 60 * 60 * 24;
        var today = new Date();
        //생성일
        var createdDate = new Date(article.createdDate.toString());
        //수정일
        var updateDateString = article.updatedDate?.toString();
        //수정일이 정의되지 않으면 바로 flase return
        if (updateDateString != null || updateDateString != undefined) {
            var updateDate = new Date(updateDateString.toString());
            //수정일이 작성일보다 클 때
            var updateDiff = updateDate.getTime() - createdDate.getTime();
            // 수정일이 하루 차이 날 때
            var updateTimeSpan = today.getTime() - updateDate.getTime();

            //임시저장 문서는 표시되지 않음
            if (updateDiff > 0 && updateTimeSpan <= oneDay && article.isDraft == false) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    selectItem() {
        this.setCurrentArticle(this.item);
        this.$router.push({ path: `/board/read?boardId=${this.item.boardId}&articleId=${this.item.articleId}` });
    }

    getDate(dateStr: string, format: string) {
        return dateutil.uGetDateFormat(format, dateutil.IEDate(dateStr));
    }
    
    showreplyLevel(article: article.Article) {
        if (article.parentArticle != null) {
            return true;
        } else {
            return false;
        }
    }
}
